// extracted by mini-css-extract-plugin
module.exports = {"item":"faqSearchResults_item__LoJnI"};